import { merge } from '@bingads-webui/primitive-utilities';
import { paginationStyle } from '@bingads-webui-campaign-react/common-styles';

const flexStyle = {
  overflow: 'hidden',
  display: 'flex',
  flex: 1,
  position: 'relative',
  flexDirection: 'column',
};

export const getOverviewStyles = () => ({
  '@global': {
    '& .brand-table-hide': {
      visibility: 'hidden',
    },
    '.brand-page .table-container table.table thead.header tr th': {
      '&:first-child, &:nth-child(2)': {
        'border-right': '1px solid #EDEBE9',
      },
      '&:nth-child(5)': {
        'border-right': 'none',
      },
      '&:last-child': {
        'border-left': 'none',
      },
    },
    '.brand-page .table-container table.table tbody tr td': {
      'overflow-wrap': 'break-word',
      '&:first-child, &:nth-child(2)': {
        'border-right': '1px solid #EDEBE9',
      },
      '&:nth-child(5)': {
        'border-right': 'none',
        '&:hover': {
          'border-right': 'none',
        },
      },
      '&:last-child': {
        'border-left': 'none',
        '&:hover': {
          'border-left': 'none',
        },
      },
    },
    '.brand-page .bingadsgrid .table-container table.table tbody tr:hover': {
      '& td': {
        borderRight: '1px solid #fff',
      },
    },
    '.brand-page .bingadsgrid': {
      paddingRight: 32,
    },
    '.brand-page .container-fluid': {
      marginRight: 32,
      height: 56,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '.brand-page .top-grid-form': {
      maxWidth: 'none',
    },
    '.delete-brand': {
      background: 'none',
      'vertical-align': 'middle',
      '&:active, &:focus, &:hover': {
        border: 'none',
      },
    },
  },
  overviewContainer: {
    padding: '0 32px',
  },
  subTitle: {
    marginTop: 8,
  },
  placeholderContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  placeholderImage: {
    marginTop: 45,
    width: 292,
  },
  addBrandsTip: {
    color: '#605E5C',
    textAlign: 'center',
    fontSize: 26,
    lineHeight: '20px',
    marginTop: 45,
  },
  addButton: {
    marginTop: 45,
  },
  tileContainer: {
    height: 220,
    display: 'flex',
    margin: '20px 0',
  },
});

export const getAddBrandPanelStyles = () => ({
  panel: {
    '& .ms-Panel-scrollableContent, & .ms-Panel-contentInner, & .ms-Panel-content': {
      ...flexStyle,
    },
    '& .ms-Panel-content': {
      padding: 0,
    },
  },
  title: {
    paddingLeft: 32,
    marginTop: 0,
  },
  subtitle: {
    paddingLeft: 32,
  },
  alertInfo: {
    width: 425,
    margin: '10px 0 25px 32px',
  },
  content: {
    ...flexStyle,
    paddingLeft: 32,
    overflow: 'auto',
  },
  bottomBar: {
    borderTop: '1px solid #EDEBE9',
    padding: '0 32px',
    height: 63,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  saveButton: {
    marginRight: 12,
  },
});

export const getAddBrandPanelV2Styles = () => ({
  panel: {
    '& .ms-Panel-scrollableContent, & .ms-Panel-contentInner, & .ms-Panel-content': {
      ...flexStyle,
    },
    '& .ms-Panel-content': {
      padding: 0,
    },
  },
  title: {
    paddingLeft: 32,
    marginTop: 0,
    display: 'flex',
    alignItems: 'center',
  },
  subtitle: {
    paddingLeft: 32,
  },
  alertInfo: {
    width: 496,
    margin: '10px 0 25px 32px',
  },
  content: {
    ...flexStyle,
    padding: '0 32px',
    overflow: 'auto',
  },
  bottomBar: {
    borderTop: '1px solid #EDEBE9',
    padding: '0 32px',
    height: 63,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  saveButton: {
    marginRight: 12,
  },
  BrandSelector: {
    '& .manually-add-btn': {
      marginBottom: 24,
    },
    '& .selected-count': {
      display: 'flex',
      gap: '10px',
    },
    '& .selected-items': {
      display: 'flex',
      gap: '6px',
      flexWrap: 'wrap',
    },
  },
});

export const getManuallyAddBrandStyles = () => ({
  brandLabel: {
    fontSize: 14,
    fontWeight: 600,
  },
  brandFormItem: {
    height: 80,
  },
  brandInfoInput: {
    width: 400,
  },
  tips: {
    background: '#EFF6FC',
    width: 400,
    padding: '8px 32px',
  },
  errorHint: {
    color: '#A80000',
  },
});

export const getCampaignTileStyles = () => ({
  ShoppingCampaignTile: {
    width: 606,
    height: 330,
    borderRadius: 2,
    position: 'relative',
    '& .tile-content': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    '& .tile-contents-container': {
      flex: 1,
      marginBottom: 0,
    },
    '& .tile-header': {
      height: 44,
    },
    '& .tile-header-container': {
      marginTop: 5,
    },
    '& .tile-footer': {
      height: 48,
    },
    '& .ms-DetailsHeader': {
      paddingTop: 0,
    },
    '& .ms-DetailsList': {
      marginTop: '-14px',
    },
    '& .ms-DetailsRow-cell': {
      padding: '8px 0 8px 12px',
      minHeight: 34,
    },
    '& .ms-DetailsRow-fields': {
      minHeight: 34,
    },
    '& .ms-DetailsRow': {
      minHeight: 34,
    },
    '& .ms-ContextualMenu-container': {
      width: 100,
    },
  },
  tileHeader: {
    fontSize: 14,
  },
  createCampaignContainer: {
    display: 'flex',
  },
  createCampaignTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 290,
    height: 182,
    margin: '20px 88px 0 15px',
  },
  createCampaignTitle: {
    lineHeight: '28px',
  },
  createCampaignDesc: {
    marginBottom: 24,
  },
  createCampaignBtn: {
    padding: '10px 16px',
  },
  adCard: {
    width: 129,
    height: 230,
    boxShadow: '0px 2px 10px #ccc',
    borderRadius: 6,
  },
  adImageBox: {
    position: 'relative',
  },
  editPenImage: {
    position: 'absolute',
    left: '-56px',
    top: 24,
  },
  adDesc: {
    padding: '8px 6px',
    fontSize: 15,
  },
  adName: {
    color: '#1A0DAB',
  },
  adPrice: {
    fontWeight: 500,
    color: '#444444',
  },
  adCategory: {
    color: '#006621',
  },
  spinnerModal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    background: 'rgba(255,255,255,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  campaignStatusIcon: {
    position: 'absolute',
    left: 8,
    fontWeight: 600,
  },
  campaignLink: {
    paddingLeft: 14,
  },
  activeCampaignIcon: {
    fontSize: 18,
    left: 6,
    top: 5,
    color: '#107C10',
  },
  columnHeader: {
    position: 'relative',
    paddingLeft: 18,
  },
  headerCheveribDownIcon: {
    position: 'absolute',
    left: 0,
  },
});

export const getChartTileStyles = () => ({
  chartTileContainer: {
    width: 606,
    height: 330,
    borderRadius: 2,
    marginRight: 16,
    '& .tile-content': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    '& .tile-contents-container': {
      marginBottom: 0,
      marginTop: 0,
      overflow: 'hidden',
    },
  },
  tileHeader: {
    fontSize: 14,
  },
});

export const getDataTileStyles = () => ({
  dataTileContainer: {
    width: 500,
    height: 200,
    borderRadius: 2,
    marginRight: 16,
    position: 'relative',
    '& .datatile-content': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      height: '200px!important',
      width: '500px!important',
    },
    '& .tile-contents-container': {
      marginBottom: 0,
      marginTop: 0,
      overflow: 'hidden',
    },
    '& .datatile-buttons .btn': {
      marginRight: 12,
    },
  },
  showTips: {
    '& .datatile-content': {
      height: '236px!important',
    },
  },
  tileHeader: {
    fontSize: 14,
  },
  dataWrapper: {
    display: 'flex',
  },
  dataItem: {
    width: 193,
    margin: '22px 0 28px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dataCount: {
    fontSize: 28,
    fontWeight: 600,
  },
  dataDesc: {
    fontSize: 12,
    color: '#323130',
  },
  alertInfo: {
    marginTop: 10,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& .alert-info-inline': {
      textWrap: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
});

export const getBrandSelectorStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '@global': merge(
    {
      '& .arrow-button': {
        color: '#0078D4',
      },
      '& .arrow-button.enabled': {
        marginLeft: 10,
        overflow: 'visible !important',
        textDecoration: 'none !important',
        background: 'none !important',
        fontFamily: iconFontFamily,
        cursor: 'pointer',
      },

      '& .arrow-button.enabled:before': {
        content: '"\\E710"',
      },

      '& .arrow-button.remove': {
        marginTop: 8,
        float: 'right',
        fontFamily: iconFontFamily,
        padding: 0,
      },
      '& .arrow-button.remove:before': {
        content: '"\\E738"',
      },
      '& .arrow-button.remove+a': {
        width: 'fit-content',
        padding: 0,
      },
      '& .list-selector-container': {
        height: '470px!important',
      },
      '& .list-selector-content': {
        height: '365px!important',
      },
      '& .multi-selector-result-container': {
        height: '540px!important',
      },
      '& .multi-selector-result-container .list-selector-container': {
        height: '540px!important',
      },
      '& .multi-selector-result-container .list-selector-content': {
        height: '450px!important',
      },
      '& .multi-selector-content': {
        height: '540px!important',
      },
      '& .ba-entity-selector': {
        height: '540px!important',
      },
      '& .ba-list-selector': {
        height: '470px!important',
        justifyContent: 'space-between!important',
      },
      '.ba-list-selector .list-selector-action-bar .select-all-content': {
        padding: '10px 12px 10px 8px!important',
      },
      '.ba-list-selector .list-selector-action-bar .remove-all-content': {
        padding: '10px 12px 10px 8px!important',
      },
      '& .multi-selector-result-container .ba-list-selector': {
        height: 'auto!important',
        justifyContent: 'flex-start!important',
      },
    },
    paginationStyle({ palette })
  ),
});
